<template>
  <div class="report-viewer-container">
    <iframe
      v-if="reportGuid"
      ref="reportFrame"
      :src="iframeSrc"
      class="report-iframe"
      frameborder="0"
      @load="onIframeLoad"
    ></iframe>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <span>正在加载报表...</span>
    </div>
    <div v-if="!reportGuid && !loading" class="error-overlay">
      <span>缺少报表参数</span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const reportFrame = ref(null)
const loading = ref(true)

const reportGuid = computed(() => route.query.reportGuid || '')

const iframeSrc = computed(() => {
  if (!reportGuid.value) return ''
  return `/Reports/view/table.html?reportGuid=${encodeURIComponent(reportGuid.value)}`
})

function onIframeLoad() {
  loading.value = false
}

onMounted(() => {
  if (!reportGuid.value) {
    loading.value = false
  }
})
</script>

<style scoped>
.report-viewer-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    overflow: hidden;
    background: #f5f7fa;
}
.report-iframe {
    width: 100%;
    height: 100%;
    border: none;
}
.loading-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #666;
    font-size: 14px;
}
.loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #e5e7eb;
    border-top-color: #319eec;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}
@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>
